import styled from 'styled-components';

export const ParticipantWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
